/**
 * Admin Modules governance API
 * GET /api/v1/admin/modules - List modules with probe status
 * POST /api/v1/admin/modules/probe - Run probe
 */

import { apiGet, apiPost } from './apiClient.js';

export async function getModules() {
  try {
    const data = await apiGet('/admin/modules', { cache: 'no-store' });
    return data;
  } catch (err) {
    if (err?.status !== undefined) throw err;
    const e = new Error(err?.message || 'Failed to load modules');
    e.status = err?.status;
    throw e;
  }
}

export async function runProbe() {
  try {
    return await apiPost('/admin/modules/probe', {});
  } catch (err) {
    if (err?.status !== undefined) throw err;
    const e = new Error(err?.message || 'Probe failed');
    e.status = err?.status;
    throw e;
  }
}
